<template>
  <pt-propmotion-detail class="pt-propmotion-detail__page" :id="id"></pt-propmotion-detail>
</template>

<script>
import PtPropmotionDetail from 'cps/mall-manage/pt-promotion-review/pt-propmotion-detail/withData'
export default {
  name: 'pt-propmotion-detail__view',
  components: {
    'pt-propmotion-detail': PtPropmotionDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>
